/* eslint-disable functional/prefer-readonly-type */

import type { ImageSourcePropType } from 'react-native';
import { PixelRatio } from 'react-native';

/**
 * Returns asset/source based on current screen DPI.
 */
export function getImageForCurrentScreen(
  source: ImageSourcePropType[] | ImageSourcePropType,
) {
  if (!Array.isArray(source)) return source;

  const screenPixelRatio = Math.ceil(PixelRatio.get());
  const lastAvailableImage = source[source.length - 1];

  return source[screenPixelRatio - 1] ?? lastAvailableImage;
}
